import { make } from "vuex-pathify";

// properties
const state = {
  open: false,
  newList: false,
  showCompleted: false,
  loading: false,
  menu: {
    open: false,
    tab: null,
  },
  main: {
    tab: null,
  },
  menuPanel: null,
  source: "server",
  betaDays: 0,
  dropdown: {
    open: true,
    component: null,
  },
  task: {
    controls: {
      schedule: null,
    },
  },
  modal: {
    signIn: false,
    analytics: false,
    email: {
      report: {
        open: false,
        list: null,
      },
    },
    list: {
      new: {
        open: false,
      },
      edit: {
        open: false,
        list: null,
      },
      import: {
        open: false,
        tab: null,
      },
      save: {
        open: false,
        list: null,
      },
    },
  },
};

const mutations = make.mutations(state);
const getters = {
  ...make.getters(state),
};
const actions = {};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
